/**
 * Mocks for React Native native-only modules that are not available in react-native-web
 */

export const PermissionsAndroid = {
  PERMISSIONS: {
    CAMERA: 'camera',
    WRITE_EXTERNAL_STORAGE: 'write_external_storage',
    READ_EXTERNAL_STORAGE: 'read_external_storage',
    ACCESS_FINE_LOCATION: 'access_fine_location',
    ACCESS_COARSE_LOCATION: 'access_coarse_location',
  },
  check: () => Promise.resolve(true),
  request: () => Promise.resolve('granted'),
  requestMultiple: (permissions) => {
    const results = {};
    permissions.forEach(p => results[p] = 'granted');
    return Promise.resolve(results);
  },
};

export const TurboModuleRegistry = {
  get: () => null,
  getEnforcing: () => null,
};

export const requireNativeComponent = (viewName) => {
  console.warn(`requireNativeComponent("${viewName}") is not supported on web.`);
  return () => null;
};

export default {
  PermissionsAndroid,
  TurboModuleRegistry,
  requireNativeComponent,
};
